import React from "react";
import { Server, RefreshCw } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/shared/components/ui/select";
import { useLanguage } from "@/shared/components/shared/LanguageContext";

export default function InfrastructureHeader({
  timeRange,
  setTimeRange,
  handleRefresh,
  refreshing,
}) {
  const { t } = useLanguage();

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-slate-700 to-slate-900 flex items-center justify-center">
          <Server className="h-6 w-6 text-white" />
        </div>
        <div>
          <h1 className="text-xl sm:text-2xl font-bold text-slate-900">{t("serverInfrastructure")}</h1>
          <p className="text-slate-500">{t("realTimeMonitoring")}</p>
        </div>
      </div>
      <div className="flex w-full sm:w-auto items-center gap-2">
        <Select value={timeRange} onValueChange={setTimeRange}>
          <SelectTrigger className="w-full sm:w-[120px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="1h">{t("last1h")}</SelectItem>
            <SelectItem value="6h">{t("last6h")}</SelectItem>
            <SelectItem value="24h">{t("last24h")}</SelectItem>
            <SelectItem value="7d">{t("last7d")}</SelectItem>
          </SelectContent>
        </Select>
        <Button variant="outline" onClick={handleRefresh} className="gap-2 w-full sm:w-auto" disabled={refreshing}>
          <RefreshCw className={`h-4 w-4 ${refreshing ? "animate-spin" : ""}`} />
          {t("refresh")}
        </Button>
      </div>
    </div>
  );
}
